import { render } from "./PortfolioGenerator.vue?vue&type=template&id=677f5e0e&scoped=true"
import script from "./PortfolioGenerator.vue?vue&type=script&lang=js"
export * from "./PortfolioGenerator.vue?vue&type=script&lang=js"

import "./PortfolioGenerator.vue?vue&type=style&index=0&id=677f5e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f5e0e"]])

export default __exports__